export const INIT_FILTERS = {
    campusId: 0,
    resourceModuleId: 0,
    libraryId: 0,
    spaceTypeId: 0,
    resourceTypeId: "",
    spaceId: 0
};
export const FILTER_STYLE_PROPS = {
    CUSTOM_SELECT: {
        width: {
            container: "200px",
            containerSelect: "100%"
        },
        minWidth: "200px"
    },
};